import { useCallback, useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { IGenericPayload } from "../../../../../../../models";
import { fetchInspectorOptions } from "../../../../../../../redux/actions/user/users/users";
import { useAppDispatch, useAppSelector } from "../../../../../../../redux/hooks";
import { IAssignInspector, updateAssignInspectorFormProperty } from "../../../../../../../redux/reducers/request/list/form/assignInspector";
import { compileNameOfProperty, getGenericPayloadFromEvent } from "../../../../../../../utils";
import { FormField } from "../../../../../../common/fields/fields";
import { StringSelectorFilter } from "../../../../selectors/selectorFilter/StringSelectorFilter";
import { RequestListExpedientsAddInspectorContainerStyle } from "./formStyle.jss";

export const RequestListExpedientsAddInspectorContainer = () => {
    const { t } = useTranslation("common", { keyPrefix: "LIST.EXPEDIENTS_DESCRIPTIONS.ASSIGN_INSPECTOR" });
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const style = RequestListExpedientsAddInspectorContainerStyle({ theme });

    const { form } = useAppSelector((store) => store.assignInspectorForm);
    const { organismId } = useAppSelector((store) => store.userData.profile);
    const { options } = useAppSelector((store) => store.usersByRole.allInspectors);

    console.log("AssignInspectorForm", options);

    const { register } = useForm<IAssignInspector>({ mode: "onChange" });
    const updatePropertyForm = (propertyName: string, value: any) => {
        const payload: IGenericPayload = {
            name: propertyName,
            value,
        };
        dispatch(updateAssignInspectorFormProperty(payload));
    };
    const onInputChange = useCallback(
        (event: any) => {
            const { name, value } = getGenericPayloadFromEvent(event);
            updatePropertyForm(name, value);
        },
        [dispatch],
    );
    
    const onSelectorChange = (name: string, value: any) => {
        console.log("onSelectorChange", name, value);
        updatePropertyForm(name, value);
    };

    useEffect(() => {
        form.organismId && dispatch(fetchInspectorOptions(form.organismId ?? organismId));
    }, [organismId]);

    useMemo(() => {
        if (options.length === 1 && options[0].key !== "" && !form.inspectorId) {
            updatePropertyForm(compileNameOfProperty<IAssignInspector>("inspectorId"), options[0].key);
        }
    }, [options, form]);

    return (
        <div className={style.formContainer}>
            <FormField
                type="text"
                value={form.expedientNumber}
                maxLength={255}
                label={t("EXPEDIENT_NUMBER")}
                {...register(compileNameOfProperty<IAssignInspector>("expedientNumber"), {
                    onChange: onInputChange,
                    value: form.expedientNumber,
                    required: true,
                })}
                isRequired={true}
                disabled={true}
            />

            <StringSelectorFilter 
                key={String(0) + t("INSPECTOR")}
                selectedKey={form.inspectorId}
                label={t("INSPECTOR")}
                onChange={onSelectorChange}
                propertyName={compileNameOfProperty<IAssignInspector>("inspectorId")}
                options={useMemo(() => options, [options])}
            />
        </div>
    );
};
